<template>
  <div class="tab-content">
      <div class="pagenamPT">
        <h3 class="pagename2">{{ $t('front.cash.changesInMoney') }}</h3>
      </div>
      <div class="partnerTop">
        <div class="search-check">
          <div class="title"><span>{{ $t('front.common.detailCondition') }} :</span></div>
          <div class="content">
            <div class="chk">
              <label for="a">{{ $t('front.gameCategory.all') }}</label>
              <input type="checkbox" id="a" :checked="selectAll" @click="toggleAllCheckboxes" />
            </div>
            <template v-for="item in cashTypeList" :key="item.code">
              <div class="chk">
                <label :for="item.code">{{ item.label }}</label>
                <input type="checkbox" :id="item.code" :checked="item.checked" @click="toggleCheckbox(item)" />
              </div>
            </template>
          </div>
        </div>
        <div class="fx-center-end">
          <input type="text" class="input" :placeholder="$t('front.common.memId')" v-model="searchMemId"/>
          <date-filter-Pt :startDate="startDate"
                          :endDate="endDate"
                          @update="updateDate"
                          @search="loadLog" />
          <div class="ck">
            <input type="checkbox" id="z" :checked="oldYn === 'Y'" @click="setOldYn"/>
            <label for="z">{{ $t('front.common.searchData') }}</label>
          </div>
        </div>
      </div>
      <div class="strTableWrap">
        <div class="strTablescr">
            <div class="strTablePC">
              <table class="strTablePT">
                <colgroup>
                  <col style="width:10%;">
                  <col style="width:10%;">
                  <col style="width:10%;">
                  <col style="width:10%;">
                  <col style="width:10%;">
                  <col style="width:10%;">
                  <col style="width:10%;">
                  <col style="width:10%;">
                  <col style="width:10%;">
                  <col style="width:10%;">
                </colgroup>
                <thead>
                  <tr>
                    <th>{{ $t('front.board.regDate') }}</th>
                    <th>{{ $t('front.common.completeTime') }}</th>
                    <th>{{ $t('front.common.memId') }}</th>
                    <th>{{ $t('front.common.nickName') }}</th>
                    <th>{{ $t('front.common.category') }}</th>
                    <th>{{ $t('front.common.moneyBefore') }}</th>
                    <th>{{ $t('front.common.changeable') }}</th>
                    <th>{{ $t('front.common.moneyAfter') }}</th>
                    <th>{{ $t('front.board.status') }}</th>
                    <th>{{ $t('front.give.etc') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="cashTransLogs && cashTransLogs.length > 0">
                    <template v-for="cash in cashTransLogs" :key="cash.cashIdx">
                      <tr>
                        <td><span class="date">{{ cash.regDate.replace('T', ' ') }}</span></td>
                        <td><span class="date">{{ cash.updDate.replace('T', ' ') }}</span></td>
                        <td>{{ cash.memId }}</td>
                        <td class="nick">{{ cash.memNick }}</td>
                        <td>{{ cash.typeDesc }}</td>
                        <td>{{ thousand(cash.preCashAmt || 0) }}</td>
                        <td class="minusAmt">{{ thousand(cash.cashAmt || 0) }}</td>
                        <td>{{ thousand(cash.postCashAmt || 0) }}</td>
                        <td>{{ cash.statusDesc }}</td>
                        <td><span class="txt">{{ cash.memo }}</span></td>
                      </tr>
                    </template>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="10">{{ $t('front.common.notFoundList') }}</td>
                    </tr>
                  </template>

                </tbody>
              </table>
            </div>
            <!-- <div class="strTableM">
              <div class="strTablePTM">
                <ul>
                  <template v-if="cashTransLogs && cashTransLogs.length > 0">
                    <template v-for="cash in cashTransLogs" :key="cash.cashIdx">
                      <li>
                        <em>등록일시</em>
                        <div>{{ cash.regDate.replace('T', ' ') }}</div>
                      </li>
                      <li>
                        <em>처리 완료 시간</em>
                        <div>{{ cash.updDate.replace('T', ' ') }}</div>
                      </li>
                      <li>
                        <em>아이디</em>
                        <div>{{ cash.memId }}</div>
                      </li>
                      <li>
                        <em>닉네임</em>
                        <div class="nick">{{ cash.memNick }}</div>
                      </li>
                      <li>
                        <em>유형</em>
                        <div>{{ cash.typeDesc }}</div>
                      </li>
                      <li>
                        <em>변동 전 머니</em>
                        <div>{{ thousand(cash.preCashAmt || 0) }}</div>
                      </li>
                      <li>
                        <em>변동 머니</em>
                        <div class="minusAmt">{{ thousand(cash.cashAmt || 0) }}</div>
                      </li>
                      <li>
                        <em>변동 후 머니</em>
                        <div>{{ thousand(cash.postCashAmt || 0) }}</div>
                      </li>
                      <li>
                        <em>상태</em>
                        <div>{{ cash.statusDesc }}</div>
                      </li>
                      <li>
                        <em>비고</em>
                        <div><span class="txt">{{ cash.memo }}</span></div>
                      </li>
                    </template>
                  </template>
                  <template v-else>
                    <li>{{ $t('front.common.notFoundList') }}</li>
                  </template>
                </ul>
              </div>
            </div> -->
        </div>
      </div>
    <pagination v-if="pageInfo"
                :pageNum="pageInfo.page"
                :pageSize="pageInfo.count_per_list"
                :totalCount="pageInfo.tatal_list_count"
                :className="'partnerPaging'"
                @goToPage="loadLog" />
  </div>
</template>

<script>
import DateFilterPt from '@/components/ui/DateFilterPt'
import Pagination from '@/components/ui/Pagination.vue'
import { mapState } from 'vuex'
import { getCashTransLogV2 } from '@/api/v2/cash'
import { getCode } from '@/api/common'
import { getDateStr, thousand } from '@/libs/utils'
import { addDays } from 'date-fns'
export default {
  name: 'cashListMy',
  components: { DateFilterPt, Pagination },
  computed: {
    ...mapState([
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode'
    ])
  },
  data () {
    return {
      cashTypeList: [],
      cashTypeEtcList: [],
      cashTransLogs: null,
      selectAll: true,
      searchMemId: '',
      oldYn: 'N',
      startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
      endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59')
    }
  },
  async created () {
    let result = await getCode('typeInfo', 'cashType')
    // console.log('code : ', result)
    const firstSelectCode = ['1', '-1', '-19', '19', '-3', '3']
    result.forEach(item => {
      if (firstSelectCode.includes(item.code)) {
        item.checked = true
      }
      item.label = this.$i18n.locale === 'ko' ? item.codeName : item['codeName' + this.$i18n.locale.toUpperCase()]
    })

    result = result.filter(item => {
      if (item.codeName.indexOf('홀덤') > -1 || item.codeName.indexOf('스포츠') > -1) {
        this.cashTypeEtcList.push(item.code)
        return false
      }
      return true
    })

    result.push({
      checked: false,
      code: 'etc',
      label: 'etc'
    })

    this.cashTypeList = result
    console.log('cashTypeList', result)

    this.loadLog()
  },
  watch: {
  },
  methods: {
    thousand,
    updateDate (value) {
      this.startDate = value.startDate
      this.endDate = value.endDate
    },
    setOldYn () {
      this.oldYn = this.oldYn === 'Y' ? 'N' : 'Y'
    },
    toggleAllCheckboxes () {
      this.cashTypeList.forEach((checkbox) => {
        if (checkbox.id !== 'a') {
          checkbox.checked = !this.selectAll
        }
      })
      this.selectAll = !this.selectAll
    },
    toggleCheckbox (checkbox) {
      checkbox.checked = !checkbox.checked
      this.selectAll = this.cashTypeList.every((checkbox) => checkbox.checked)
    },
    loadLog (page) {
      console.log(page, this.pageInfo.page)
      if (!page) {
        page = this.pageInfo.page
      }
      if (page === true) {
        page = 1
      }
      this.cashTransLogs = null

      let cashTypeList = this.cashTypeList.filter(item => {
        return item.checked
      }).map(item => {
        return item.checked ? item.code : null
      })

      let isEtc = false
      cashTypeList.forEach(code => {
        if (code === 'etc') {
          isEtc = true
        }
      })

      if (isEtc) {
        cashTypeList = [
          ...cashTypeList,
          ...this.cashTypeEtcList
        ]

        cashTypeList = cashTypeList.filter(item => {
          return item !== 'etc'
        })
      }

      const params = {
        page: page,
        memId: this.searchMemId,
        startDate: this.startDate,
        endDate: this.endDate,
        cashTypeList: cashTypeList.length > 0 ? cashTypeList : null,
        oldYn: this.oldYn
      }
      console.log(params)
      getCashTransLogV2(params).then(res => {
        const result = res.data
        console.log('getCashTransLogV2 : ', params, result)
        if (result.resultCode === '0') {
          this.cashTransLogs = result.data.cashTransLogs
          console.log(this.cashTransLogs)
          if (result.data.pageInfo) {
            this.pageInfo = result.data.pageInfo
          }
        }
      })
    }
  }
}
</script>

<style src="@/styles/striNew.css"></style>
<style scoped>
/* ===============================
   보유머니 변동내역 - 디자인 전용 수정
   구조/스크립트 변경 없음
================================ */

/* 페이지 헤더 */
.pagenamPT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 22px;
}

.pagename2 {
  margin: 0;
  color: #07152a;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.6px;
}

/* 검색/체크 조건 카드 */
.partnerTop {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 24px;
  padding: 22px 24px;
  margin-bottom: 18px;
  border: 1px solid #d8e2f1;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(15, 35, 70, 0.06);
  box-sizing: border-box;
}

/* 상세조건 */
.search-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.search-check {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 18px;
  width: 100%;
  min-width: 0;
  color: #17233c;
  font-size: 13px;
}

.search-input-area {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
}

@media (max-width: 1200px) {
  .search-wrap {
    gap: 12px;
  }

  .search-check {
    gap: 14px;
  }

  .search-input-area {
    gap: 8px;
  }
}
.search-check .title {
  flex: 0 0 auto;
  padding-top: 4px;
  font-weight: 800;
  color: #253045;
  white-space: nowrap;
}

.search-check .content {
  display: grid;
  grid-template-columns: repeat(5, minmax(118px, 1fr));
  gap: 9px 14px;
  width: 100%;
  max-width: none;
}

.search-check .chk {
  width: auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 0;
  box-sizing: border-box;
}

.search-check label {
  min-width: 0;
  color: #273247;
  font-size: 13px;
  font-weight: 700;
  text-align: right;
  line-height: 1.25;
  word-break: keep-all;
}

.search-check input[type='checkbox'],
.ck input[type='checkbox'] {
  width: 14px !important;
  min-width: 14px !important;
  height: 14px !important;
  margin: 0;
  padding: 0 !important;
  accent-color: #2f6df6;
  cursor: pointer;
}

/* 우측 검색영역 */
.fx-center-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
  margin-left: auto;
}

.input {
  width: 280px;
  height: 40px !important;
  margin: 0;
  padding: 0 13px !important;
  border: 1px solid #d6dfed !important;
  border-radius: 7px !important;
  background: #fff;
  color: #17233c;
  font-size: 14px !important;
  box-sizing: border-box;
  outline: none;
}

.input:focus {
  border-color: #2f6df6 !important;
  box-shadow: 0 0 0 3px rgba(47, 109, 246, 0.12);
}

.ck {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 40px;
  margin: 0;
  white-space: nowrap;
}

.ck label {
  color: #273247;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

/* DateFilterPt 내부 보정 */
.fx-center-end :deep(.datesearchPT),
.fx-center-end :deep(.datesearchPTWarp),
.fx-center-end :deep(.datesearch),
.fx-center-end :deep(.dateWrap) {
  display: flex;
  align-items: center;
  gap: 0;
  margin: 0 !important;
}

.fx-center-end :deep(input[type='date']),
.fx-center-end :deep(input[type='text']) {
  height: 40px !important;
  min-width: 136px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 1px solid #d6dfed !important;
  border-radius: 0 !important;
  background: #fff !important;
  color: #17233c !important;
  font-size: 14px !important;
  box-sizing: border-box;
}

.fx-center-end :deep(input[type='date']:first-child),
.fx-center-end :deep(input[type='text']:first-child) {
  border-radius: 7px 0 0 7px !important;
}

.fx-center-end :deep(.dateBtn),
.fx-center-end :deep(.bga),
.fx-center-end :deep(button) {
  height: 40px !important;
  min-width: 58px !important;
  margin: 0 0 0 8px !important;
  padding: 0 14px !important;
  border: 0 !important;
  border-radius: 7px !important;
  background: #2f6df6 !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  box-shadow: 0 5px 12px rgba(47, 109, 246, 0.22);
  cursor: pointer;
}

.strTableWrap {
  width: 100%;
  display: block;
  margin-top: 0;
  overflow-x: scroll;
}

.strTablescr {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #d8e2f1;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(15, 35, 70, 0.06);
  box-sizing: border-box;
}

.strTablePC {
  width: 100%;
  min-width: 1100px;
  box-sizing: border-box;
}

.strTablePT {
  width: 100%;
  min-width: 1050px;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-top: 3px solid #2f6df6;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}

.strTablePT th {
  height: 46px;
  padding: 0 10px;
  border: 0;
  border-bottom: 1px solid #dbe4f0;
  background: #f5f8fc;
  color: #07152a;
  font-size: 13px;
  font-weight: 800;
  text-align: center;
  line-height: 1.3;
  white-space: nowrap;
}

.strTablePT td {
  min-height: 44px;
  height: 44px;
  padding: 9px 10px;
  border: 0;
  border-bottom: 1px solid #e7edf5;
  background: #fff;
  color: #17233c;
  font-size: 13px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.35;
  box-sizing: border-box;
}

.strTablePT td .date{
  display: inline-block;
  white-space: break-spaces;
}

.strTablePT tbody tr:nth-child(even) td {
  background: #fafcff;
}

.strTablePT tbody tr:hover td {
  background: #f3f7ff;
}

.strTablePT tbody tr:last-child td {
  border-bottom: 0;
}

.nick {
  color: #ff7e00 !important;
  font-weight: 800;
}

.minusAmt {
  color: #0b63f6 !important;
  font-weight: 800;
}

.txt {
  display: inline-block;
  max-width: 260px;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.45;
  color: #17233c;
}

/* 빈 데이터 */
.strTablePT td[colspan='10'] {
  height: 54px;
  color: #6b7485;
  font-weight: 700;
  background: #fff;
}

/* 페이지네이션 위치 */
:deep(.partnerPaging),
:deep(.pagination),
:deep(.paging) {
  margin-top: 20px;
}

/* 모바일 */
@media (max-width: 1200px) {
  .partnerTop {
    flex-direction: column;
    gap: 18px;
  }

  .fx-center-end {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .search-check .content {
    grid-template-columns: repeat(4, minmax(105px, 1fr));
  }
}

@media (max-width: 1000px) {
  .pagenamPT {
    align-items: flex-start;
  }

  .partnerTop {
    padding: 16px;
    border-radius: 11px;
  }

  .search-check {
    flex-direction: column;
    gap: 10px;
  }

  .search-check .title {
    padding-top: 0;
  }

  .search-check .content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px 12px;
  }

  .search-check .chk {
    min-height: 28px;
    gap: 5px;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
  }

  .search-check label {
    font-size: 13px;
    text-align: right;
    line-height: 1.3;
    word-break: keep-all;
  }

  .search-check input[type='checkbox'] {
    flex: 0 0 14px;
  }

  .fx-center-end {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .input {
    width: 100%;
    height: 38px !important;
  }

  .ck {
    height: 32px;
  }

  .fx-center-end :deep(.datesearchPT),
  .fx-center-end :deep(.datesearchPTWarp),
  .fx-center-end :deep(.datesearch),
  .fx-center-end :deep(.dateWrap) {
    width: 100%;
    display: flex;
    gap: 6px !important;
  }

  .fx-center-end :deep(input[type='date']),
  .fx-center-end :deep(input[type='text']) {
    flex: 1 1 0;
    width: 100% !important;
    min-width: 0 !important;
    height: 38px !important;
    padding: 0 8px !important;
    border-radius: 8px !important;
    font-size: 12px !important;
  }

  .fx-center-end :deep(.dateBtn),
  .fx-center-end :deep(.bga),
  .fx-center-end :deep(button) {
    flex: 0 0 54px;
    min-width: 54px !important;
    height: 38px !important;
    margin-left: 0 !important;
    padding: 0 !important;
    border-radius: 8px !important;
  }

  .strTablescr {
    border-radius: 11px;
  }

  .strTablePC {
    min-width: 980px;
    padding: 0 10px 10px;
  }

  .strTablePT {
    min-width: 950px;
  }
}

@media (max-width: 520px) {
  .search-check .content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 9px 8px;
  }

  .search-check .chk {
    min-height: 27px;
    gap: 4px;
  }

  .search-check label {
    font-size: 12px;
  }
}

@media (max-width: 360px) {
  .search-check .content {
    gap: 8px 5px;
  }

  .search-check label {
    font-size: 11px;
  }

  .search-check input[type='checkbox'] {
    width: 13px !important;
    min-width: 13px !important;
    height: 13px !important;
  }
}
</style>
